import useMuiMediaQuery from '@mui/material/useMediaQuery';
import '@famly/mf_theme';
export const useMediaQuery = (fn) => {
    return useMuiMediaQuery(theme => fn(theme.breakpoints));
};
